/* AA ring cart support v1. Does not intercept unrelated cart lines or replace native events. */
(() => {
  if (window.aaRingCartReady) return;
  window.aaRingCartReady = true;
  const root = () => window.Shopify?.routes?.root || "/";
  let busy = false;
  const groupElement = target => target.closest("line-item[data-aarc-group]") || target.closest("tr")?.querySelector("line-item[data-aarc-group]");
  const getCart = async () => {
    const r = await fetch(root()+"cart.js");if(!r.ok)throw new Error("Your cart could not be checked. Please try again.");return r.json();
  };
  const status = message => {
    let node=document.querySelector("[data-aarc-cart-status]");
    if(!node){node=document.createElement("p");node.setAttribute("data-aarc-cart-status","");node.setAttribute("role","alert");node.style.cssText="padding:12px;border:1px solid #111;font-size:12px;line-height:1.5";(document.querySelector("cart-drawer [slot=footer]")||document.querySelector(".cart-recap")||document.querySelector("cart-drawer")||document.body).prepend(node);}
    node.textContent=message;
  };
  const refresh = () => {
    if(window.location.pathname.replace(/\/$/,"").endsWith("/cart"))window.location.reload();
    else document.documentElement.dispatchEvent(new CustomEvent("cart:refresh",{bubbles:true}));
  };
  const update = async (group,quantity) => {
    if(busy)return;busy=true;
    const elements=Array.from(document.querySelectorAll("line-item[data-aarc-group]")).filter(e=>e.dataset.aarcGroup===group);
    elements.forEach(e=>e.setAttribute("aria-busy","true"));
    try {
      const cart=await getCart(),items=cart.items.filter(x=>x.properties?._aarc_group===group);
      const parent=items.find(x=>x.properties._aarc_role==="ring");if(!parent)throw new Error("Refresh your cart before changing this ring.");
      const updates={};items.forEach(x=>updates[x.key]=quantity);
      const r=await fetch(root()+"cart/update.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({updates})});
      const result=await r.json();if(!r.ok)throw new Error(result.description||"Your ring quantity could not be updated.");
      refresh();
    }catch(error){status(error.message);refresh();}
    finally{busy=false;elements.forEach(e=>e.removeAttribute("aria-busy"));}
  };
  document.addEventListener("change",e=>{
    const target=e.target;
    if(!target.matches?.("[data-line-key]"))return;
    const el=groupElement(target);if(!el)return;
    e.preventDefault();e.stopImmediatePropagation();
    if(el.dataset.aarcRole==="addon"){status("Your upgrades belong to this ring. Change the ring quantity to update the complete selection.");return;}
    const quantity=parseInt(target.value,10);if(Number.isFinite(quantity)&&quantity>=0)update(el.dataset.aarcGroup,quantity);
  },true);
  document.addEventListener("click",e=>{
    const anchor=e.target.closest?.('a[href*="/cart/change"]');if(!anchor)return;
    const el=groupElement(anchor);if(!el)return;
    e.preventDefault();e.stopImmediatePropagation();
    if(el.dataset.aarcRole==="addon"){status("Your upgrades belong to this ring. Remove the ring to remove its complete selection.");return;}
    const url=new URL(anchor.href);const quantity=parseInt(url.searchParams.get("quantity"),10);
    if(Number.isFinite(quantity)&&quantity>=0)update(el.dataset.aarcGroup,quantity);
  },true);
  const check = async () => {
    const cart=await getCart();
    for(const parent of cart.items.filter(x=>x.properties?._aarc_role==="ring")){
      let expected;
      try{expected=JSON.parse(parent.properties._aarc_expected||"[]");}catch(e){throw new Error("This ring's customization could not be checked. Please return to the ring page.");}
      const children=cart.items.filter(x=>x.properties?._aarc_group===parent.properties._aarc_group&&x.properties._aarc_role==="addon");
      if(children.length!==expected.length||expected.some(x=>!children.some(c=>Number(c.variant_id)===Number(x.id)&&c.quantity===parent.quantity))){
        throw new Error("This ring's upgrades have changed. Remove this ring and add your complete selection again before checking out.");
      }
    }
  };
  document.addEventListener("click",async e=>{
    const button=e.target.closest?.('[name="checkout"],a[href$="/checkout"],a[href*="/checkout?"]');
    if(!button||!document.querySelector("line-item[data-aarc-group]"))return;
    e.preventDefault();e.stopImmediatePropagation();
    if(busy)return;busy=true;button.setAttribute("aria-busy","true");
    try{await check();window.location.assign(root()+"checkout");}catch(error){status(error.message);}
    finally{busy=false;button.removeAttribute("aria-busy");}
  },true);
  document.addEventListener("submit",async e=>{
    if(!e.target.matches?.('form[action*="/cart"]')||e.submitter?.name!=="checkout"||!document.querySelector("line-item[data-aarc-group]"))return;
    e.preventDefault();e.stopImmediatePropagation();if(busy)return;busy=true;
    try{await check();window.location.assign(root()+"checkout");}catch(error){status(error.message);}finally{busy=false;}
  },true);
})();